import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import ModalCreatePlan from "../ModalCreatePlan";
import { hideModal, showModal } from "../../../../store/actions/modal";
import { getGroupById } from "../../../../store/actions/group";
import { Group } from "../../../../types";

interface ComponentProps {
  groupInformation: Group | null;
  newPlanSuccess: boolean;
}

const SECTION_REGEX = /^\/dashboard\/(membership|experience)\/(\d+)(?:\/([^/]+))?/;

const matchGroupSection = (pathname: string) => {
  const m = pathname.match(SECTION_REGEX);
  if (!m) return null;
  return {
    group_type: m[1],
    idGroup: m[2],
    section: m[3] || null,
  };
};

const Component = ({ groupInformation, newPlanSuccess }: ComponentProps) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const match = useMemo(() => matchGroupSection(pathname), [pathname]);

  const groupMatches =
    !!match && groupInformation?.id === Number(match.idGroup);
  const plansCount = groupInformation?.plans?.length || 0;
  const isPricePage = match?.section === "price";
  const shouldShow = groupMatches && plansCount === 0 && !isPricePage;

  // Recargar el group cuando se cree un plan, para que el modal desaparezca
  useEffect(() => {
    if (newPlanSuccess && match?.idGroup) {
      dispatch(getGroupById({ group_id: match.idGroup }));
    }
  }, [newPlanSuccess, match?.idGroup, dispatch]);

  // Mostrar el modal mientras el grupo no tenga planes y reabrir al cambiar de sección
  useEffect(() => {
    if (shouldShow) {
      dispatch(showModal("create-first-plan-modal"));
    } else if (groupMatches && plansCount > 0) {
      dispatch(hideModal());
    }
  }, [shouldShow, pathname, groupMatches, plansCount, dispatch]);

  if (!shouldShow || !groupInformation) return null;

  const page =
    groupInformation.group_type === "membership" ? "membresía" : "taller";

  return <ModalCreatePlan group={groupInformation} page={page} />;
};

const state = ({ groupStore, planStore }: any) => ({
  groupInformation: groupStore?.group?.data || null,
  newPlanSuccess: planStore?.newPlan?.states?.success || false,
});

export default connect(state)(Component);
